import { render } from "./VtcEnLigne.vue?vue&type=template&id=9085eb0c"
import script from "./VtcEnLigne.vue?vue&type=script&lang=js"
export * from "./VtcEnLigne.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__